import Grid from '@mui/material/Grid';
import FormInput from '../query-builder/hooks-form-querybuilder/form-input.component';



interface IDivisionForm {
  editItem?: Partial<any> | undefined;
}
export const FastFieldQueueForm = ({ editItem }: IDivisionForm) => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput
          label="Workorder Number"
          name="reinspectionwo"
          maxLength={150}
          autoFocus
          disabled={!!editItem?.divisionID}
        />
      </Grid>
    </Grid>
  );
};
